{
  "template": {
    "type": "map-block",
    "map": {
      "zoom": 9,
      "id": "common-places",
      "center": [55.753994, 37.622093],
      "markers": [
        {
          "address": "Moscow Arbat",
          "label": {
            "preset": "islands#circleIcon"
          }
        },
        {
          "coordinate": [55.733974, 37.587093],
          "label": {
            "iconCaption": "Yandex",
            "iconColor": "#3caa3c"
          }
        }
      ]
    },
    "title": "Lorem ipsum dolor sit",
    "description": "**Ut enim ad minim veniam** [quis nostrud](https://example.com) exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    "additionalInfo": "Duis aute irure dolor in [reprehenderit](https://example.com) n voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    "links": [
      {
        "url": "#",
        "text": "Learn more",
        "theme": "normal",
        "arrow": true
      }
    ],
    "buttons": [
      {
        "text": "Button",
        "theme": "action",
        "url": "https://example.com"
      },
      {
        "text": "Button",
        "theme": "outlined",
        "url": "#"
      }
    ]
  }
}
